import { compose, withHandlers, withProps } from 'recompose';
import { withRouter } from 'react-router';

import AutoPayoutEligibilityStep from './AutoPayoutEligibilityStep';
import withNotifications from '../../../../../common/withNotifications';
import { AUTO_PAYOUT_ELIGIBILITY_ACTIVE_FINANCING_URL } from '../../../../../common/KnowledgeArticleLink/constants';

export default compose(
  withRouter,
  withNotifications,
  withProps(() => ({
    name: 'No Capital Financing',
    description: 'Complete the financing offer repayment process.',
    knowledgeArticleUrl: AUTO_PAYOUT_ELIGIBILITY_ACTIVE_FINANCING_URL,
    eligibilityActionDescription: 'Go to Financing',
  })),
  withHandlers(({
    onEligibilityActionClicked: props => () => {
      props.router.push('/financing');
    },
  })),
)(AutoPayoutEligibilityStep);
